export default "__VITE_ASSET__DcE8M1yB__"